const PRIORITY = {
  "Nízká": "bg-muted text-muted-foreground",
  "Střední": "bg-blue-500/15 text-blue-400",
  "Vysoká": "bg-destructive/15 text-destructive",
};
const STATUS = {
  "Nový": "bg-muted text-muted-foreground",
  "V řešení": "bg-brand/15 text-brand",
  "Hotovo": "bg-amber-500/15 text-amber-500",
  "Schváleno": "bg-emerald-500/15 text-emerald-500",
};

// V API je „Hotovo" = pracovník odeslal ke kontrole a „Schváleno" = uzavřeno.
// Na obrazovce tomu říkáme tak, jak to lidi chápou (hodnoty v API se nemění).
export const STATUS_LABEL = {
  "Nový": "Nový", "V řešení": "V řešení",
  "Hotovo": "Ke schválení", "Schváleno": "Hotovo",
};

export function PriorityBadge({ value }) {
  return <span className={`inline-flex px-2 py-0.5 text-xs font-bold rounded-sm ${PRIORITY[value] || ""}`}>{value}</span>;
}
export function TaskStatusBadge({ value }) {
  return <span className={`inline-flex px-2 py-0.5 text-xs font-bold uppercase tracking-wide rounded-sm ${STATUS[value] || ""}`}>{STATUS_LABEL[value] || value}</span>;
}
